<div class="card max-w-2xl mx-auto mt-8">
  <div class="card-body p-8">
    <h2 class="text-2xl font-bold mb-6 text-gray-900 dark:text-white-100">
      Upload FinCEN Files
    </h2>

    <form [formGroup]="uploadForm" (ngSubmit)="uploadFiles()" class="space-y-6">
      <!-- Date of File(s) -->
      <div class="space-y-2">
        <label 
          for="upload-date" 
          class="block text-sm font-medium text-gray-700 dark:text-white-300"
        >
          Date of file(s) <span class="text-red-500">*</span>
        </label>
        <kendo-datepicker
          id="upload-date"
          formControlName="uploadDate"
          [min]="minDate"
          [max]="maxDate"
          class="w-full"
          placeholder="Select date"
        ></kendo-datepicker>
        <div 
          *ngIf="uploadForm.get('uploadDate')?.invalid && uploadForm.get('uploadDate')?.touched"
          class="text-sm text-red-600 dark:text-red-400 mt-1"
        >
          Date is required
        </div>
      </div>

      <!-- Person File Upload -->
      <div class="space-y-2">
        <label 
          for="person-file" 
          class="block text-sm font-medium text-gray-700 dark:text-white-300"
        >
          Choose a Person file:
        </label>
        <input
          #personFileInput
          id="person-file"
          type="file"
          accept=".csv,.txt"
          (change)="onPersonFileSelect($event)"
          class="block w-full text-sm text-gray-900 dark:text-white-100 
                 border border-gray-300 dark:border-gray-600 rounded-lg cursor-pointer 
                 bg-gray-50 dark:bg-gray-800 focus:outline-none 
                 file:mr-4 file:py-2 file:px-4
                 file:rounded-l-lg file:border-0
                 file:text-sm file:font-semibold
                 file:bg-blue-50 file:text-blue-700
                 dark:file:bg-blue-900 dark:file:text-blue-300
                 hover:file:bg-blue-100 dark:hover:file:bg-blue-800"
        />
        <div class="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Allowed: .csv, .txt (Max: 1 GB)
        </div>
        <div *ngIf="personFile" class="text-sm text-green-600 dark:text-green-400">
          Selected: {{ personFile.name }} ({{ formatFileSize(personFile.size) }})
        </div>
      </div>

      <!-- Business File Upload -->
      <div class="space-y-2">
        <label 
          for="business-file" 
          class="block text-sm font-medium text-gray-700 dark:text-white-300"
        >
          Choose a Business file:
        </label>
        <input
          #businessFileInput
          id="business-file"
          type="file"
          accept=".csv,.txt"
          (change)="onBusinessFileSelect($event)"
          class="block w-full text-sm text-gray-900 dark:text-white-100 
                 border border-gray-300 dark:border-gray-600 rounded-lg cursor-pointer 
                 bg-gray-50 dark:bg-gray-800 focus:outline-none 
                 file:mr-4 file:py-2 file:px-4
                 file:rounded-l-lg file:border-0
                 file:text-sm file:font-semibold
                 file:bg-blue-50 file:text-blue-700
                 dark:file:bg-blue-900 dark:file:text-blue-300
                 hover:file:bg-blue-100 dark:hover:file:bg-blue-800"
        />
        <div class="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Allowed: .csv, .txt (Max: 1 GB)
        </div>
        <div *ngIf="businessFile" class="text-sm text-green-600 dark:text-green-400">
          Selected: {{ businessFile.name }} ({{ formatFileSize(businessFile.size) }})
        </div>
      </div>

      <!-- Error Message -->
      <div 
        *ngIf="errorMessage" 
        class="p-3 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded text-sm text-red-700 dark:text-red-400"
      >
        {{ errorMessage }}
      </div>

      <!-- Submit Button -->
      <div class="flex justify-center">
        <button
          type="submit"
          [disabled]="uploadForm.invalid || isUploading || (!personFile && !businessFile)"
          class="px-6 py-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-white-100 
                 border border-gray-300 dark:border-gray-600 rounded shadow-sm 
                 hover:bg-gray-50 dark:hover:bg-gray-600 focus:outline-none 
                 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
                 disabled:opacity-50 disabled:cursor-not-allowed
                 transition-colors duration-200"
        >
          <span *ngIf="!isUploading">Upload</span>
          <span *ngIf="isUploading" class="flex items-center justify-center">
            <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-900 dark:text-white-100" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Uploading...
          </span>
        </button>
      </div>

      <!-- Upload Progress -->
      <div *ngIf="isUploading" class="space-y-2">
        <div class="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2.5">
          <div 
            class="bg-blue-600 h-2.5 rounded-full transition-all duration-300" 
            [style.width.%]="uploadProgress"
          ></div>
        </div>
        <p class="text-sm text-center text-gray-600 dark:text-gray-400">
          {{ uploadProgress }}% uploaded
        </p>
      </div>

      <!-- Results Message -->
      <div 
        *ngIf="resultsMessage" 
        class="p-3 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded text-sm text-green-700 dark:text-green-400"
      >
        {{ resultsMessage }}
      </div>
    </form>
  </div>
</div>
